import styles from './VacancyItem.module.css'
import Button from '../UI/Button/Button'
import { useNavigate } from 'react-router-dom'

interface Vacancy {
  id: number
  title: string
  location: string
  tasks: string[]
  requirements: string[]
  work_hours: string
}

export default function VacancyItem({ vacancy }: { vacancy: Vacancy }) {
  const navigate = useNavigate()

  const handleApplyClick = () => {
    navigate('/careers/details', { state: { vacancy } })
  }

  return (
    <div className={styles.vacancy_item}>
      <div className={styles.vacancy_info_wrapper}>
        <h4>{vacancy.title}</h4>
        <h4>{vacancy.location}</h4>
      </div>
      <Button
        roundType="small_rounded"
        paddingType="big"
        onClick={handleApplyClick}
        aria-label={`Откликнуться на вакансию ${vacancy.title}`}
      >
        Откликнуться
      </Button>
    </div>
  )
}
